/*
 *
 *  FUNCTIONS
 *  contains basic js fot the entire website
 *  this file is always loaded on the bottom of the page
 *  !! Created by Ilse on 05/08/2016
 *
 */
import 'slick-carousel';

$(document).ready(function () {

    //-- Clicking on the cookie button
    $('div.cookies').click(function (e) {
        if ($(e.target).hasClass('btn')) {
            $(this).hide();
            $.post(strAjaxPath + 'cookies.php', function () {
            });
        }
    });


    // 1. TOUCH OR NO TOUCH
    //check between touch and not touch
    function is_touch_device() {
        return (('ontouchstart' in window)
            || (navigator.MaxTouchPoints > 0)
            || (navigator.msMaxTouchPoints > 0));
    }

    // 2. make every link with rel=external work as a target _blank link
    // used instead of inline target blank for validation reasons
    $('a[rel=\'external\']').click(function () {
        $(this).attr('target', '_blank');
    });
    // 3. Menu slide toggle
    // when clicked on the link give the body an extra classe
    // slidetoggle is made with css (structure.scss)
    $('.mobile-nav-toggle').on('click touchstart', function () {
        $('body').toggleClass('menu-open');
        $('.product-nav').toggleClass('d-none');
        return false;
    });

    $('.toggle-filters').on('click touchstart', function () {
        $('body').toggleClass('filters-open');
        return false;
    });

    if (is_touch_device()) {
        // if touch device no hover but click, only on devices larger then 768, smaller is link through
        if ($(window).width() >= 768) {
            $('div.mini-cart > a').on('click touchstart', function () {
                $('div.mini-cart').toggleClass('showsub');
                return false;
            });
        }
    }

    //get the head navigaiton to work on click on touch devices
    if ($(window).width() >= 992) {
        if (is_touch_device()) {
            //click on a headnavigation item
            $('nav.navigation ul li a.sublink').each(function () {
                $(this).on('click touchstart', function () {
                    if ($(this).parent().hasClass('hover')) {
                        var href = $(this).attr('href');
                        window.location.href = href;

                    } else {
                        $('nav.navigation ul li').removeClass('hover');
                        $(this).parent().addClass('hover');
                        return false;
                    }
                });
            });

            // When clicked outside of the li-items: remove every 'hover' class on the li-elements
            $('body').on('click touchstart', function (event) {
                if (!$(event.target).is('nav.navigation ul, nav.navigation ul li, nav.navigation ul li a')) {
                    $('nav.navigation ul, nav.navigation ul li').removeClass('hover');
                }
            });
        }
    } else {
        $('nav.nav-lang  a.font-weight-bold').on('click', function () {
            $(this).parent().toggleClass('active');
            return false;
        });
    }

    // Fancybox
    $('[data-fancybox], a.fancybox').fancybox({
        loop: false,
        protect: true,
        keyboard: true,
        toolbar: false,
        buttons: [
            'close'
        ],
        animationEffect: 'fade',
        animationDuration: 366,
        transitionEffect: 'slide',
        clickContent: function (current, event) {
            return current.type === 'image' ? 'zoom' : false;
        }
    });

    // slick
    if ($('.slider-wrapper').length > 0) {

        var intTestimonialItems = $('.slider-wrapper div.testimonials > div').length;

        if (intTestimonialItems > 0) {
            $('.slider-wrapper div.testimonials').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: true
            });
        }

        var intSlideItems = $('.slider-wrapper div.slider > div').length;
        if (intSlideItems > 0) {
            $('.slider-wrapper div.slider').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    }

    if ($('a[data-anchor]').length > 0) {
        var objAnchorMink = $('a[data-anchor]');

        objAnchorMink.on('click', function () {
            var strAnchor = $(this).attr('data-anchor');
            var objDivAnchor = $('div[data-anchor="' + strAnchor + '" ]');

            $('html, body').animate({
                scrollTop: objDivAnchor.offset().top
            }, 500);

            window.location.hash = objDivAnchor.attr('data-hash');
            return false;
        });
    }

    if ($('a[href*="#"]').length > 0) {
        var objAnchorLink = $('a[href*="#"]');

        objAnchorLink.on('click', function () {
            var strhash = $(this).attr('href');//get url
            var strHashCheck = new String(strhash);

            if (strHashCheck.length > 1) {

                var objDivAnchor = $('div[data-hash="' + strhash + '" ]');

                $('html, body').animate({
                    scrollTop: objDivAnchor.offset().top
                }, 500);

                window.location.hash = objDivAnchor.attr('data-hash');
                return false;
            }
        });
    }

});
//  Animated numbers
$(window).on('load', function () {
    // Hash
    var strhash = window.location.hash;
    if (strhash.length > 0) {
        var objHashAnchor = $('div[data-hash="' + strhash + '" ]');
        $('html, body').animate({
            scrollTop: objHashAnchor.offset().top
        }, 500);
    }


    // animated numbers
    var intPbicons = $('.pb-lerian-icoontjes').length;
    if (intPbicons > 0) {
        var objIconswrapper = $('.pb-lerian-icoontjes');
        var objIcon = $('.pb-lerian-icoon');
        var intIcons = objIcon.length;
        var objFirstnumber = objIcon.first().find('.number');
//offset icons
        var intOffset = objIconswrapper.offset().top;
        var intfirstnumberOffset = objFirstnumber.offset().top;

        // window height & doc height
        var intWindowHeight = $(window).outerHeight();
        var intDocumentHeight = $(document).outerHeight();
        // End of page
        var intMaxOffset = intDocumentHeight - intWindowHeight;

        if (intIcons > 0) {
            $(window).scroll(function (event) {
                var intscroll = $(window).scrollTop();
                var intVisible = intfirstnumberOffset - intWindowHeight + 100;

                // if you scroll to the block or the block is on the bottom of the page do the running up number
                if (intscroll >= intVisible || intscroll >= intMaxOffset) {
                    objIcon.each(function () {
                        // Get the actual number
                        var intNumber = $(this).find('span.endnumber').html();
                        // Get the start number
                        var intStartNumber = $(this).find('b.number').html();
                        // Trim the numbers (remove spaces)
                        var intCleanNumber = intNumber.split(" ").join("");
                        var intCleanStartNumber = $.trim(intStartNumber.split(" ").join(""));

                        // If the number has not been shown
                        if (intCleanStartNumber <= 0) {
                            $(this).find('.number').animateNumber({
                                easing: 'swing',
                                number: intCleanNumber,
                                duration: 150000
                            });
                        }
                    });
                }
            });
        }
    }
});

// Limit counter (for limit on textarea)
// Used for: the giftcard
function UpdateCountdown(objMessage, objCountdown, intLimit, strLabel) {
    var intRemaining = intLimit - objMessage.val().length;
    // Make sure you can't go over the max. number of characters
    if (intRemaining <= 0) {
        objMessage.val(objMessage.val().substr(0, intLimit));
        intRemaining = 0;
    }

    // Notification
    objCountdown.text(strLabel.replace('[NUMBER]', intRemaining));
}

// Html entity decode (for special characters)
// Used for: Ajax response
function html_entity_decode(str) {
    try {
        var tarea = document.createElement('textarea');
        tarea.innerHTML = str;
        return tarea.value;
        tarea.parentNode.removeChild(tarea);
    } catch (e) {
        //for IE add<div id="htmlconverter" style="display:none;"></div> to the page
        document.getElementById('htmlconverter').innerHTML = '<textarea id="innerConverter">' + str + '</textarea>';
        var content = document.getElementById('innerConverter').value;
        document.getElementById('htmlconverter').innerHTML = '';
        return content;
    }
}

// local and session storage
// Used for: the wishlist
function GetLocalStorage(strName) {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && localStorage[strName]) {
        strItem = localStorage.getItem(strName);
    }

    return strItem;
}

function SetLocalStorage(strName, strValue) {
    if (typeof (Storage) !== 'undefined') {
        localStorage.setItem(strName, strValue);
    }
}

function GetSessionStorage(strName) {
    var strItem = '';

    if (typeof (Storage) !== 'undefined' && sessionStorage[strName]) {
        strItem = sessionStorage.getItem(strName);
    }

    return strItem;
}

function SetSessionStorage(strName, strValue) {
    if (typeof (Storage) !== 'undefined') {
        sessionStorage.setItem(strName, strValue);
    }
}

window.SetSessionStorage = SetSessionStorage;
window.GetSessionStorage = GetSessionStorage;
window.SetLocalStorage = SetLocalStorage;
window.GetLocalStorage = GetLocalStorage;
window.html_entity_decode = html_entity_decode;
window.UpdateCountdown = UpdateCountdown;
